// The print page's address carries what the panel was showing — the group shown alone,
// the state filter and the search — so the page prints exactly that. The grouping and
// the order are not in it: they are saved on the list (079) and the page reads them there.
export const printUrl = (taskId, { groupKey, stateId, query }) => {
  const q = new URLSearchParams();
  if (groupKey) q.set('group', groupKey);
  if (stateId) q.set('state', String(stateId));
  if (query && query.trim()) q.set('q', query.trim());
  const s = q.toString();
  return `/lists/${taskId}/print${s ? `?${s}` : ''}`;
};

export const readPrintFilters = (search) => {
  const q = new URLSearchParams(search);
  return {
    groupKey: q.get('group') || null,
    stateId: q.get('state') ? Number(q.get('state')) : null,
    query: q.get('q') || '',
  };
};
